export default __webpack_public_path__ + "static/media/AcheronianStronghold.f79b952b.jpg";